const commentItems = [
  {
    name: '视频达人小王',
    date: '2026年7月28日',
    content: '这个导航站真的太实用了！以前找个靠谱的视频平台要翻半天，现在直接在这里就能看到所有热门平台的入口，香蕉视频和蜜桃视频的资源确实丰富，推荐给大家。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20friendly%20smile%2C%20clean%20white%20background%2C%20modern%20casual%20style%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20simple%20composition&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
  },
  {
    name: '追剧小能手',
    date: '2026年7月25日',
    content: '红桃视频的自制内容质量真的不错，樱花视频的日剧资源也很全。通过这个导航站一次就能找到所有想看的平台，省时省力，已经推荐给身边的朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20expression%2C%20clean%20light%20background%2C%20natural%20makeup%2C%20soft%20studio%20lighting%2C%20simple%20aesthetic%2C%20friendly%20vibe&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
  },
  {
    name: '老司机带路',
    date: '2026年7月22日',
    content: '作为多年的视频网站用户，这个导航站在平台收录方面做得挺全。91视频的原创社区氛围很好，西瓜视频的推荐算法也越来越精准了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%20with%20confident%20look%2C%20clean%20neutral%20background%2C%20casual%20business%20style%2C%20warm%20lighting%2C%20simple%20editorial%20portrait&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
  },
  {
    name: '影迷小K',
    date: '2026年7月20日',
    content: '每周都会来看看有没有新的视频平台收录进来，糖豆视频的短视频很适合打发时间。希望你们能持续更新，收录更多优质的在线视频网站。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20bright%20smile%2C%20clean%20white%20studio%20background%2C%20natural%20light%2C%20casual%20friendly%20style%2C%20simple%20composition&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">用户推荐</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            看看视频爱好者们如何评价我们的导航服务
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}